import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { VoiceVisualService } from './voice-visualization.service';


@Injectable({ providedIn: 'root' })
export class VoiceGlowService {
    private sub?: Subscription;

    constructor(private visual: VoiceVisualService) { }

    start() {
        if (this.sub) return;
        this.sub = this.visual.level$().subscribe(v => {
            const clamped = Math.max(0, Math.min(1, v));
            document.documentElement.style.setProperty('--voice', clamped.toFixed(3));
        });
    }

    stop() {
        this.sub?.unsubscribe();
        this.sub = undefined;
        document.documentElement.style.setProperty('--voice', '0');
    }
}
